'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sagaMiddleware = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _reduxRequestMiddleware = require('@wh/redux-request-middleware');

var _reduxRequestMiddleware2 = _interopRequireDefault(_reduxRequestMiddleware);

var _reduxLoggerMiddleware = require('@wh/redux-logger-middleware');

var _reduxLoggerMiddleware2 = _interopRequireDefault(_reduxLoggerMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sagaMiddleware = exports.sagaMiddleware = (0, _reduxSaga2.default)();

/**
 * Composes the application middlewares by combining the default middlewares with the client defined ones
 * @param   {ClientMiddlewareType} [appMiddleware] The middlewares specified if any. Defaults to an empty array
 * @returns {ClientMiddlewareType} The combined array of middlewares
 * @private
 */
var getMiddleware = function getMiddleware() {
  var appMiddleware = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return [_reduxRequestMiddleware2.default, _reduxLoggerMiddleware2.default, sagaMiddleware].concat((0, _toConsumableArray3.default)(appMiddleware));
};

exports.default = getMiddleware;
//# sourceMappingURL=middleware.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/site-base-app-container/dist/main/middleware.js
// module id = 179
// module chunks = 0